export function getLinkStyle(url) {
    try {
        var params = new URLSearchParams(new URL(url).search);
        var style = params.get('link_style');
        return style && JSON.parse(window.atob(style));
    }
    catch (e) {
        return undefined;
    }
}
export function getNumber(def, value) {
    return value !== undefined ? value : def;
}
